<div class="product" [ngClass]="{ 'black-friday': isBlackFriday }">
  <shared-product-card
    [product]="productCard"
    [homeIndexData]="homeIndexData"
    [expandMode]="expandMode"
    [isBlackFriday]="isBlackFriday"
  >
  </shared-product-card>
</div>
